document.addEventListener("DOMContentLoaded", () => {
  const configEl = document.querySelector(".js-loading-config");
  const ENABLE_LOADING = configEl?.dataset.enableLoading === "true";

  const loading = document.querySelector(".js-loading");
  const logo = document.querySelector(".a-loading__img");
  const title = document.querySelector(".js-mv-title");
  const sub = document.querySelector(".js-mv-sub");
  const mvImg = document.querySelector(".js-mv-img img");

  if (typeof gsap === "undefined" || !mvImg) {
    loading?.remove();
    return;
  }

  const hasPlayed = sessionStorage.getItem("openingPlayed");

  // ===== MV 初期状態 =====
  if (title) {
    gsap.set(title, {
      opacity: 0,
      visibility: "visible",
      clipPath: "polygon(0 0,1% 0,1% 100%,0 100%)",
      willChange: "clip-path, opacity"
    });
  }
  
  if (sub) {
    gsap.set(sub, {
      opacity: 0,
      visibility: "visible",
      clipPath: "polygon(0 0,1% 0,1% 100%,0 100%)",
      willChange: "clip-path, opacity"
    });
  }

  gsap.set(mvImg, { scale: 1.1 });

  // ===== MVアニメ =====
  const playMv = () => {
    const tl = gsap.timeline();

    tl.to(mvImg, {
      scale: 1,
      duration: 9.5,
      ease: "power2.out"
    });

    if (title) {
      tl.to(title, {
        opacity: 1,
        clipPath: "polygon(0 0,100% 0,100% 100%,0 100%)",
        duration: 2.1,
        ease: "power1.out"
      }, "-=8.5");
    }

    if (sub) {
      tl.to(sub, {
        autoAlpha: 1,
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        duration: 1.6,
        ease: "power1.out"
      }, "-=7");
    }
  };

  // ===== ローディング使わない =====
  if (!ENABLE_LOADING || hasPlayed || !loading || !logo) {
    loading?.remove();
    playMv();
    return;
  }

  // ===== ローディング使う（初回のみ） =====
  sessionStorage.setItem("openingPlayed", "true");

  // 🔑 ここで初めて表示する
  gsap.set(loading, {
    autoAlpha: 1,
    pointerEvents: "auto"
  });

  gsap.set(logo, {
    autoAlpha: 0,
    filter: "blur(24px)",
    y: 10
  });

  gsap.timeline({
    onComplete: () => {
      loading.remove();
      document.dispatchEvent(new CustomEvent('loadingComplete'));
    }
  })
    .to(logo, {
      autoAlpha: 1,
      filter: "blur(0px)",
      y: 0,
      duration: 1.4,
      ease: "power2.out"
    })
    .to({}, { duration: 1.0 })
    .to(loading, {
      autoAlpha: 0,
      duration: 1.0,
      ease: "power2.inOut"
    })
    .add(playMv, "<");
});

/**** メインスクリプト（まとめて安全に読み込む）*****/
document.addEventListener("DOMContentLoaded", () => {

  /* ==========================
      Lenis → ScrollTrigger
     ========================== */
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => 1 - Math.pow(1 - t, 4),
    smooth: true,
    smoothTouch: true,
    wheelMultiplier: 0.85,
    // ツールチップモーダル内はLenisのスムーススクロール対象外にする
    prevent: (node) => node.closest('.tool-tip__content') !== null,
  });

  // Lenisをグローバルに公開
  window.lenis = lenis;

  gsap.ticker.add((t) => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);

  gsap.registerPlugin(ScrollTrigger);
  lenis.on("scroll", ScrollTrigger.update);


  /* ==========================
       fadein スクロールアニメ
     ========================== */
  gsap.utils.toArray('.js-fadein').forEach((el) => {
    gsap.fromTo(el,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      }
    );
  });


  /* ==========================
        About セクション
     ========================== */
  function initAboutChapter() {
    const wrapper = document.querySelector(".a-about-chapter");
    const inner = document.querySelector(".a-about-chapter__inner");
    const contents = gsap.utils.toArray(".a-about-chapter__content");

    if (!wrapper || !inner || contents.length === 0) return;

    const headerHeight = 122;
    const sectionH = window.innerHeight - headerHeight;
    const totalH = sectionH * contents.length;

    wrapper.style.height = `${totalH}px`;
    inner.style.height = `${sectionH}px`;

    contents.forEach((c, i) => {
      const img = c.querySelector(".a-about-chapter__content-img");
      if (!img) return;
      gsap.set(img, {
        clipPath: i === 0
          ? "polygon(0% 0%,100% 0%,100% 100%,0% 100%)"
          : "polygon(0% 100%,100% 100%,100% 100%,0% 100%)"
      });
    });

    // About 内だけ kill
    ScrollTrigger.getAll().forEach((st) => {
      if (st.trigger && st.trigger.closest(".a-about-chapter")) st.kill();
    });

    // pin
    ScrollTrigger.create({
      trigger: wrapper,
      start: `top top+=${headerHeight}`,
      end: `+=${totalH - sectionH}`,
      pin: inner,
      scrub: 1,
    });

    // 画像切り替え
    contents.forEach((c, i) => {
      if (i === 0) return;
      const img = c.querySelector(".a-about-chapter__content-img");

      gsap.fromTo(
        img,
        { clipPath: "polygon(0% 100%,100% 100%,100% 100%,0% 100%)" },
        {
          clipPath: "polygon(0% 0%,100% 0%,100% 100%,0% 100%)",
          ease: "power2.out",
          scrollTrigger: {
            trigger: wrapper,
            start: `top+=${(i - 0.5) * sectionH + headerHeight} top`,
            end: `top+=${i * sectionH + headerHeight} top`,
            scrub: 1,
          }
        }
      );
    });

    // テキスト切り替え
    const texts = gsap.utils.toArray(".a-about-chapter__content-desc");

    gsap.set(texts, { autoAlpha: 0, zIndex: 0 });
    gsap.set(texts[0], { autoAlpha: 1, zIndex: 2 });

    contents.forEach((content, i) => {
      if (i === 0) return;

      const triggerStart = (i * sectionH) - (sectionH * 0.4) + headerHeight;

      ScrollTrigger.create({
        trigger: wrapper,
        start: `top+=${triggerStart} top`,
        end: `top+=${triggerStart + 1} top`,
        scrub: false,
        onEnter: () => {
          gsap.to(texts[i - 1], { autoAlpha: 0, duration: 0.6 });
          gsap.set(texts[i], { zIndex: 2 });
          gsap.to(texts[i], { autoAlpha: 1, duration: 0.6 });
        },
        onEnterBack: () => {
          gsap.to(texts[i], { autoAlpha: 0, duration: 0.6 });
          gsap.set(texts[i - 1], { zIndex: 2 });
          gsap.to(texts[i - 1], { autoAlpha: 1, duration: 0.6 });
        }
      });
    });
  }


  /* ==========================
       matchMedia
     ========================== */
  ScrollTrigger.matchMedia({
    "(min-width: 1025px)": () => {
      initAboutChapter();
      window.addEventListener("resize", initAboutChapter);
    },
    "(max-width: 1024px)": () => {
      ScrollTrigger.getAll().forEach((st) => {
        if (st.trigger && st.trigger.closest(".a-about-chapter")) st.kill();
      });
    }
  });



  /* ==========================
      FAQ アコーディオン
  ========================== */
  document.querySelectorAll(".js-faq-question").forEach((question) => {
    const answer = question.closest(".a-guide__item")?.querySelector(".js-faq-answer");
    if (!answer) return;
  
    let isOpen = question.classList.contains("is-open");
  
    if (isOpen) {
      gsap.set(answer, { height: "auto", opacity: 1 });
    } else {
      gsap.set(answer, { height: 0, opacity: 0 });
    }
  
    question.addEventListener("click", () => {
      if (gsap.isTweening(answer)) return;
  
      isOpen = !isOpen;
  
      if (isOpen) {
        question.classList.add("is-open");
        answer.classList.add("is-open");
        gsap.fromTo(answer, { height: 0, opacity: 0 }, {
          height: answer.scrollHeight,
          opacity: 1,
          duration: 0.45,
          ease: "power3.out",
          onComplete: () => {
            gsap.set(answer, { height: "auto" });
          }
        });
      } else {
        question.classList.remove("is-open");
        answer.classList.remove("is-open");
        gsap.fromTo(answer, { height: answer.offsetHeight, opacity: 1 }, {
          height: 0,
          opacity: 0,
          duration: 0.35,
          ease: "power2.inOut"
        });
      }
    });
  });

  /* ==========================
    アンカーリンク（Lenis）
  ========================== */
  const anchorLinks = document.querySelectorAll(".a-guide__category-item a")

  anchorLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");

      // href="#" or href="#!" は無視
      if (href === "#" || href === "#!") return;

      const target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();

      lenis.scrollTo(target, {
        offset: -120,   // ← ヘッダー高さぶん下げる
        duration: 1.2,
        easing: (t) => 1 - Math.pow(1 - t, 4)
      });
    });
  });
});


/* ==========================
  「メッセージ刻印」フォーム
========================== */

document.addEventListener('change', function (e) {
  if (!e.target.matches('input[name="properties[刻印]"]')) return;

  const isYes = e.target.value === 'あり';
  const textWrap = document.querySelector('[data-kokuin-text]');
  const textInput = document.getElementById('Kokuin-text');

  if (!textWrap || !textInput) return;

  if (isYes) {
    textWrap.style.display = '';
    textInput.required = true;
  } else {
    textWrap.style.display = 'none';
    textInput.required = false;
    textInput.value = '';
  }
});

document.addEventListener('input', function (e) {
  if (e.target.id !== 'Kokuin-text') return;

  const input = e.target;
  const maxLength = 15;

  if (input.value.length > maxLength) {
    input.value = input.value.slice(0, maxLength);
  }
});


/* ==========================
  トップページMVスライド
========================== */

document.addEventListener('DOMContentLoaded', () => {
  const mv = document.querySelector('.js-mv-img');
  if (!mv) return;

  const slides = mv.querySelectorAll('.a-top-mv__slide');
  if (slides.length <= 1) return;

  let index = 0;
  const interval = 5000;

  slides[index].classList.add('is-active');

  const doStart = () => {
    setInterval(() => {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, interval);
  };

  const configEl = document.querySelector('.js-loading-config');
  const enableLoading = configEl?.dataset.enableLoading === 'true';

  if (enableLoading) {
    let done = false;
    const once = () => { if (done) return; done = true; setTimeout(doStart, 2000); };
    document.addEventListener('loadingComplete', once, { once: true });
    setTimeout(once, 0);
  } else {
    doStart();
  }
});


/* ==========================
  ツールチップモーダル開閉時の制御
========================== */

// product-hot-reload によるDOM差し替えで <tool-tip> の参照が切れ、
// MutationObserver が死んでしまうため、初期化処理を再実行可能な関数に切り出す。
// 複数の <tool-tip> がある場合に備え、全件に対して張り直す。
let toolTipObservers = [];

function initToolTipScrollLock() {
  if (!window.lenis) return;

  // 差し替え前の observer が残っていれば切断してから張り直す（多重登録防止）
  toolTipObservers.forEach((observer) => observer.disconnect());
  toolTipObservers = [];

  const toolTips = document.querySelectorAll('tool-tip');
  if (!toolTips.length) return;

  toolTips.forEach((toolTip) => {
    let toolTipContent = null;
    let wheelHandler = null;
    let touchMoveHandler = null;

    // ツールチップの状態を監視
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-tool-tip-open') {
          const isOpen = toolTip.getAttribute('data-tool-tip-open') === 'true';

          if (isOpen) {
            toolTipContent = toolTip.querySelector('.tool-tip__content');
            if (!toolTipContent) return;

            // Lenisを停止して背景のスクロールを防ぐ
            window.lenis.stop();

            // モーダル内のホイールスクロールを有効化
            wheelHandler = (e) => e.stopPropagation();
            toolTipContent.addEventListener('wheel', wheelHandler, { passive: false });

            // モーダル内のタッチスクロールを有効化
            touchMoveHandler = (e) => e.stopPropagation();
            toolTipContent.addEventListener('touchmove', touchMoveHandler, { passive: false });

          } else if (toolTipContent) {
            // Lenisを再開
            window.lenis.start();

            // イベントリスナーをクリーンアップ
            if (wheelHandler) {
              toolTipContent.removeEventListener('wheel', wheelHandler);
              toolTipContent.removeEventListener('touchmove', touchMoveHandler);
            }

            // 変数をリセット
            toolTipContent = null;
            wheelHandler = null;
            touchMoveHandler = null;
          }
        }
      });
    });

    observer.observe(toolTip, {
      attributes: true,
      attributeFilter: ['data-tool-tip-open']
    });

    toolTipObservers.push(observer);
  });
}

document.addEventListener('DOMContentLoaded', initToolTipScrollLock);
document.addEventListener('product:hot-reloaded', initToolTipScrollLock);


/* ==========================
  来店予約ポップアップ開閉時の制御（Tipo Appointment Booking）
========================== */

/*
  Tipoはポップアップを開くとき body に .tpb-popup-open を付け、CSSで overflow:hidden を当てる。
  ただしテーマはLenisで仮想スクロールしているため overflow:hidden は効かず、背後がスクロールしてしまう。
  body のクラスを監視してLenis自体を stop / start する。

  注意: 同梱の lenis.min.js は prevent 関数オプションをサポートしていない。
  除外の判定は data-lenis-prevent 属性（と .lenis クラス）だけを見ており、
  さらに停止中はその判定を通らなかった wheel / touch を無条件に preventDefault する。
  そのためLenisを止めるだけだと、ポップアップ内の時間帯リストなど
  スクロールさせたい領域まで動かなくなる。
  ポップアップを開いている間は、スクロール可能な要素に data-lenis-prevent を付けて逃がす。
*/
document.addEventListener('DOMContentLoaded', () => {
  if (!window.lenis) return;

  const LENIS_PREVENT = 'data-lenis-prevent';
  // 自分で付けた印。もともと付いていた属性を閉じるときに消さないため。
  const OWN_MARK = 'data-ori-lenis-prevent';

  const isScrollable = (el) => {
    const canScrollY = el.scrollHeight > el.clientHeight + 1;
    const canScrollX = el.scrollWidth > el.clientWidth + 1;
    if (!canScrollY && !canScrollX) return false;

    const style = getComputedStyle(el);
    const scrolls = (value) => value === 'auto' || value === 'scroll' || value === 'overlay';
    return (canScrollY && scrolls(style.overflowY)) || (canScrollX && scrolls(style.overflowX));
  };

  const markScrollables = () => {
    document.body.querySelectorAll('*').forEach((el) => {
      if (el.hasAttribute(LENIS_PREVENT)) return;
      if (!isScrollable(el)) return;
      el.setAttribute(LENIS_PREVENT, '');
      el.setAttribute(OWN_MARK, '');
    });
  };

  const unmarkScrollables = () => {
    document.querySelectorAll('[' + OWN_MARK + ']').forEach((el) => {
      el.removeAttribute(LENIS_PREVENT);
      el.removeAttribute(OWN_MARK);
    });
  };

  let isLocked = false;
  let rescanTimer = null;

  // 日付を選ぶと時間帯リストが後から描画される。開いている間は再走査する。
  const rescanWhenSettled = () => {
    clearTimeout(rescanTimer);
    rescanTimer = setTimeout(markScrollables, 150);
  };

  const syncScrollLock = () => {
    const isOpen = document.body.classList.contains('tpb-popup-open');

    if (isOpen !== isLocked) {
      isLocked = isOpen;
      if (isOpen) {
        window.lenis.stop();
        // 開いた直後から中をスクロールできるよう、待たずに一度印を付ける
        markScrollables();
      } else {
        clearTimeout(rescanTimer);
        unmarkScrollables();
        window.lenis.start();
        return;
      }
    }

    if (isLocked) rescanWhenSettled();
  };

  // 監視開始前に開いている場合に備えて一度同期する
  syncScrollLock();

  new MutationObserver(syncScrollLock).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
});
